module.exports = __webpack_public_path__ + "img/b2.59cdea20.jpg";